import { Box, CircularProgress, Skeleton } from '@mui/material'
import React from 'react'
import { useStyles } from './styles'
import { TextSkeleton } from '../Skeletons'

interface PieChartSkeletonProps {
  height?: number
  loading?: boolean
  progress?: number
  progressDetails?: React.ReactElement
  showLoadingPercent?: boolean
  hideLoadingSpinner?: boolean
  children?: React.ReactNode
}

export const PieChartSkeleton: React.VFC<PieChartSkeletonProps> = ({
  height = 250,
  loading,
  progress,
  progressDetails,
  showLoadingPercent = true,
  hideLoadingSpinner,
  children,
}) => {
  const { classes } = useStyles()
  const size = height

  return (
    <Box
      sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 2, position: 'relative', width: '100%' }}
    >
      {(loading || progress) && !hideLoadingSpinner && (
        <Box
          className={classes.pieChartProgress}
          sx={theme => ({
            [theme.breakpoints.up('md')]: {
              marginTop: 50,
            },
          })}
        >
          <CircularProgress />
          {showLoadingPercent && progress !== undefined && `${(progress * 100).toFixed(2)} %`}
          {progressDetails}
        </Box>
      )}
      <Box sx={{ position: 'relative' }}>
        <Skeleton variant="circular" height={size} width={size} />
        {children}
      </Box>
      <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', width: '100%' }}>
        {new Array(4).fill('').map((_item, index) => (
          <TextSkeleton key={`text-skeleton-${index}`} variant="body1" className={classes.pieChartTextSkeleton}></TextSkeleton>
        ))}
      </Box>
    </Box>
  )
}
